import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { WalletListInterface } from '../../types/wallet-list';
import { WalletListFilter } from '../../types/wallet-list-filter';

export const fetchSenderWalletList = createAction(
  '[Sender Wallet List] Sender Wallet List Fetch',
  props<{ filter?: WalletListFilter }>()
);

export const updateSenderWalletListFilter = createAction(
  '[Wallet Filter] Sender Wallet List update filter',
  props<{ filter?: WalletListFilter }>()
);

export const loadedSenderWalletList = createAction(
  '[Sender Wallet List] Sender Wallet List Loaded',
  props<{ dataSource: DataSource<WalletListInterface[]> }>()
);

export const failedSenderWalletList = createAction(
  '[Sender Wallet List] Sender Wallet List Failed'
);

export const resetSenderWalletList = createAction(
  '[Sender Wallet List] Reset Sender Wallet List'
);
